var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('img',{staticClass:"bottom-img",attrs:{"src":require("../assets/img/Complaint.png")},on:{"click":function($event){return _vm.webToAndroid('toComplaint')}}}),_vm._v(" "),_c('img',{staticClass:"bottom-img",attrs:{"src":require("../assets/img/service.png")},on:{"click":function($event){return _vm.webToAndroid('toCustomer')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f87f5ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Service.vue
// module id = null
// module chunks = 